/**
 * Logo Configuration
 * Centralized logo path configuration for easy updates
 *
 * To update the logo:
 * 1. Place your logo file in public/logo.png (or .svg, .jpg)
 * 2. Update the LOGO_PATH constant below
 * 3. If using a different location, adjust the path accordingly
 */

// Logo path - update this to point to your logo file
// If logo is in public folder, use: "/logo.png"
// If logo is in src/assets, import it: import logoImage from "../assets/logo.png"
// export const LOGO_PATH = "/logo.jpeg";
// export const LOGO_PATH = "/mainLogo.jpg";
export const LOGO_PATH = "/logo512.png";

// Alternative: If you want to use a Cloudinary URL or external URL
// export const LOGO_PATH = "https://your-cloudinary-url.com/logo.png";

// Logo alt text
export const LOGO_ALT = "Logo";

// Login page specific logo
export const LOGIN_LOGO_PATH = "/mainLogo.jpg";
export const LOGIN_LOGO_ALT = "Logo";
